import React from 'react';
import Tabs, { Tab } from '@albertsons/uds/molecule/Tabs';
import StoreOrderTab from '../../../../common/tab/storeOrder/StoreOrderTab';
import StoreOrderHistoryTab from '../../../../common/tab/StoreOrderHistory/StoreOrderHistoryTab';
import './StoreOrder.css';

const StoreOrder = () => {
  return (
    <div>
      <div className="col-12 tab-color">
        <p>Store Order Upload</p>
      </div>
      <div className="col-12 margin-left">  
        <Tabs variant='light'>
        <Tab>
          <Tab.Header>Store Order</Tab.Header>
          <Tab.Content>
          <StoreOrderTab />
          </Tab.Content>
        </Tab>
        <Tab>
          <Tab.Header>Store Order History</Tab.Header>
          <Tab.Content>
          <StoreOrderHistoryTab />

          </Tab.Content>
        </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default StoreOrder;